<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="题目名称：" prop="name">
            <el-input style="width: 424px;" v-model="ruleForm.name" placeholder="请输入题目名称"></el-input>
          </el-form-item>
          <el-form-item label="题目类型：" prop="type">
            <el-select style="width: 424px;" v-model="ruleForm.type" placeholder="请选择" @change="typeChangeBtn" class="mt-search-width">
              <el-option
                v-for="item in topicTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.type != ''" label="选项数量：" prop="taskQuestionAnswerNumber">
            <el-input style="width: 424px;" v-model="ruleForm.taskQuestionAnswerNumber" :disabled="ruleForm.type == 3 ? true : false" @change="numberChangeBtn" placeholder="请输入选项数量"></el-input>
            <el-table
              style="width: 424px;margin-top: 24px;"
              border
              :data="ruleForm.taskQuestionAnswerSaveDtoList">
              <el-table-column
                align="left"
                prop="answer"
                label="选项内容"
                width="288">
                <template slot-scope="scope">
                  <el-input style="width: 260px;" v-model="scope.row.answer" :disabled="ruleForm.type == 3 ? true : false" placeholder="请输入选项内容"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                prop="isTrue"
                label="是否为答案">
                <template slot-scope="scope">
                  <img class="mt-table-goods-choose" @click="isChooseBtn(scope.$index)" :src="scope.row.isTrue == 1 ? imgServer+'choosed_icon.png' : imgServer+'choose_icon.png'" />
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="是否必填：" prop="isMust">
            <el-radio-group v-model="ruleForm.isMust">
                <el-radio :label="1">必填</el-radio>
                <el-radio :label="0">选填</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveIntegralTaskQuestion, fetchIntegralTaskQuestionDetailById, updateIntegralTaskQuestion } from '@/api/integral'
export default {
  name: 'IntegralMallTaskTopicAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      taskId: this.$route.query.taskId,
      topicTypeList: [{
        id:1,
        name:'单选'
      },{
        id:2,
        name:'多选'
      },{
        id:3,
        name:'判断'
      }],
      radio:'',
      ruleForm: {
        name: '',
        type: '',
        isMust: '',
        sort: '',
        status: false,
        taskQuestionAnswerNumber:1,
        taskQuestionAnswerSaveDtoList:[{
          answer:'',
          isTrue:0
        }]
      },
      rules: {
        name: [
          { required: true, message: '请输入题目名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择题目类型', trigger: 'blur' }
        ],
        isMust: [
          { required: true, message: '请选择是否必填', trigger: 'blur' }
        ],
        taskQuestionAnswerNumber: [
          { required: true, message: '请输入选项数量', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (this.dataId != '') {
      let that = this
      fetchIntegralTaskQuestionDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.name = data.name
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.sort = data.sort
          that.ruleForm.type = data.type
          that.ruleForm.isMust = data.isMust
          that.ruleForm.taskQuestionAnswerNumber = data.answerPageVoList.length
          that.ruleForm.taskQuestionAnswerSaveDtoList = data.answerPageVoList
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 题目类型改变操作
    typeChangeBtn(type){
      if(type == 3){
        this.ruleForm.taskQuestionAnswerNumber = 2;
        var taskQuestionAnswerSaveDtoList = [{
          answer:'正确',
          isTrue:0
        },{
          answer:'错误',
          isTrue:0
        }];
        this.ruleForm.taskQuestionAnswerSaveDtoList = taskQuestionAnswerSaveDtoList;
      }else{
        this.ruleForm.taskQuestionAnswerNumber = 1;
        var taskQuestionAnswerSaveDtoList = [];
        for( var i = 0 ; i < 1 ; i++ ) {
          taskQuestionAnswerSaveDtoList.push({
            answer:'',
            isTrue:0
          })
        }
        this.ruleForm.taskQuestionAnswerSaveDtoList = taskQuestionAnswerSaveDtoList;
      }
    },
    // 选项数量改变操作
    numberChangeBtn (value) {
      var taskQuestionAnswerSaveDtoList = [];
      for( var i = 0 ; i < value ; i++ ) {
        taskQuestionAnswerSaveDtoList.push({
          answer:'',
          isTrue:0
        })
      }
      this.ruleForm.taskQuestionAnswerSaveDtoList = taskQuestionAnswerSaveDtoList;
    },
    // 选项内容是否被选中
    isChooseBtn(chooseIndex){
      var taskQuestionAnswerSaveDtoList = this.ruleForm.taskQuestionAnswerSaveDtoList;
      if(this.ruleForm.type == 1 || this.ruleForm.type == 3){
        taskQuestionAnswerSaveDtoList.forEach(function(item,index){
          if(index == chooseIndex){
            item.isTrue = 1;
          }else{
            item.isTrue = 0;
          }
        })
      }else{
        taskQuestionAnswerSaveDtoList.forEach(function(item,index){
          if(index == chooseIndex){
            if(item.isTrue == 1){
              item.isTrue = 0;
            }else{
              item.isTrue = 1;
            }
            console.log(item.isTrue,'item.isTrue');
          }
        })
      }
      console.log(taskQuestionAnswerSaveDtoList,chooseIndex)
      this.ruleForm.taskQuestionAnswerSaveDtoList = taskQuestionAnswerSaveDtoList;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let taskId = that.taskId
      let name = that.ruleForm.name
      let type = that.ruleForm.type
      var isMust = that.ruleForm.isMust
      var taskQuestionAnswerSaveDtoList = that.ruleForm.taskQuestionAnswerSaveDtoList
      let status = that.ruleForm.status ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      if (name === '') {
        this.$message.error('请输入题目名称')
        return false
      }
      if (type === '') {
        this.$message.error('请选择题目类型')
        return false
      }
      if (isMust === '') {
        this.$message.error('请选择是否必填')
        return false
      }
      let passData = {
        taskId: taskId, name: name, status: status, type: type, isMust: isMust, taskQuestionAnswerSaveDtoList: taskQuestionAnswerSaveDtoList, sort: sort
      }
      console.log(passData,'passData');
      if (dataId !== '') {
        passData.id = dataId;
        updateIntegralTaskQuestion(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveIntegralTaskQuestion(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/integralMall/TaskTopicAdd.vue